export default __webpack_public_path__ + "static/light-metal-cylinders-4c65522fd3de4f5c2cacac82b99f51f3.jpg";